module.exports = __webpack_public_path__ + "static/media/drawer_profile_inactive.f826acd3.svg";